import React from 'react';
import { dollars } from 'app/src/utils/stringHelpers';

import {
  BorderedContainer,
  LotDetails,
} from './elements';

const lotDetailsOverrides = {
  fontSize: '22px',
  fontWeight: 900,
  lineHeight: 30,
  marginTop: '10px'
}

const PriorLot = ({priorSaleAsset}) => {
  return (
    <BorderedContainer
      style={{padding: '5px', borderTop: 'none', minHeight: '34vh', maxHeight: '34vh'}}
    >
      {priorSaleAsset ?
        <>
          <LotDetails style={{fontSize: '16px'}}>
            PREVIOUS LOT:
          </LotDetails>
          <LotDetails
            style={{...lotDetailsOverrides,
              fontSize: '28px'
            }}
          >
            {priorSaleAsset.lotNumber}
          </LotDetails>
          {priorSaleAsset.highBid && priorSaleAsset.highBid > 0 ?
            <LotDetails style={{...lotDetailsOverrides, fontSize: '28px'}}>
              {dollars(priorSaleAsset.highBid)}
            </LotDetails> :
            null
          }
          <LotDetails style={lotDetailsOverrides}>
            {priorSaleAsset.pendingSellerConfirmation ?
              'Pending Seller Confirmation' :
              priorSaleAsset.biddingStatus
            }
          </LotDetails>
          {priorSaleAsset.highBidDetails ?
            <>
              <LotDetails style={{...lotDetailsOverrides}}>
                {`Paddle: ${priorSaleAsset?.highBidDetails?.paddleNumber}`}
              </LotDetails>
              <LotDetails style={{...lotDetailsOverrides, marginTop: '-10px'}}>
                {`Service: ${priorSaleAsset.highBidDetails?.paddleService?.name || 'Floor'}`}
              </LotDetails>
            </> :
            null
          }
        </> :
        null
      }
    </BorderedContainer>
  )
}

export default PriorLot;
